const logs = {
    page_title: 'บันทึกการตรวจสอบ',
    title: 'บันทึกการตรวจสอบ',
    subtitle: 'ดูข้อมูลบันทึกเหตุการณ์การยืนยันตัวตนที่ผู้ใช้ของคุณดำเนินการ',
    event: 'เหตุการณ์',
    user: 'ผู้ใช้',
    application: 'แอปพลิเคชัน',
    time: 'เวลา',
    filter_by: 'กรองตาม',
};
export default Object.freeze(logs);
